import React, {useState} from "react";
import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';
import MultiRangeSlider from "multi-range-slider-react";
import { Rating } from 'react-simple-star-rating'

const Sidebar =() => {

  const [value, setValue] = useState({
    min: 35,
    max: 70,
  })
  const [duration, setDuration] = useState({
    min: 14,
    max: 90,
  })

  const [minValue, set_minValue] = useState(25);
  const [maxValue, set_maxValue] = useState(75);
  const handleInput = (e) => {
    setValue({...value, min: e.minValue, max: e.maxValue})
  };

const [rating, setRating] = useState(0) // initial rating va

// Catch Rating value
  const handleRating =(rate) => {
    setRating(rate)
  // other logic
}
    
    return (
      <div className="side-bar">
           <div className="filter_head_label">
              <h5>Filter</h5>
              <p>Set default</p>
           </div>
            <div className="option_set_">
                <Accordion defaultActiveKey={['0']} alwaysOpen>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Stream</Accordion.Header>
                    <Accordion.Body>
                        <div className="serach_bar">
                        <Form>
                          <Form.Control type="text" placeholder="Search" />
                        </Form>
                        </div>
                        <div className="check_type">
                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check 
                                  type={type}
                                  id={`default-${type}-1`}
                                  label={`Science`}
                                />

                                <Form.Check
                                  type={type}
                                  label={`Management`}
                                  id={`default-${type}-2`}
                                />

                                <Form.Check
                                  type={type}
                                  label={`Arts`}
                                  id={`default-${type}-3`}
                                />
                                <Form.Check
                                  type={type}
                                  label={`Engineering`}
                                  id={`default-${type}-4`}
                                />
                                <Form.Check
                                  type={type}
                                  label={`Computer Application`}
                                  id={`default-${type}-5`}
                                />
                                <Form.Check
                                  type={type}
                                  label={`Commerce`}
                                  id={`default-${type}-6`}
                                />
                                <Form.Check
                                  type={type}
                                  label={`Medical`}
                                  id={`default-${type}-7`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Cource</Accordion.Header>
                      <Accordion.Body>
                          <div className="check_type">
                            <Form>
                              {['checkbox'].map((type) => (
                                <div key={`default-${type}`} className="mb-3">
                                  <Form.Check 
                                    type={type}
                                    id={`default-${type}-1`}
                                    label={`Science`}
                                  />

                                  <Form.Check
                                    type={type}
                                    label={`Management`}
                                    id={`default-${type}-2`}
                                  />
                                </div>
                              ))}
                            </Form>
                          </div>
                      </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>Cource</Accordion.Header>
                      <Accordion.Body>
                          <div className="check_type">
                            <Form>
                              {['checkbox'].map((type) => (
                                <div key={`default-${type}`} className="mb-3">
                                  <Form.Check 
                                    type={type}
                                    id={`default-${type}-1`}
                                    label={`Science`}
                                  />

                                  <Form.Check
                                    type={type}
                                    label={`Management`}
                                    id={`default-${type}-2`}
                                  />
                                </div>
                              ))}
                            </Form>
                          </div>
                      </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>Cource Type</Accordion.Header>
                      <Accordion.Body>
                          <div className="check_type">
                            <Form>
                              {['checkbox'].map((type) => (
                                <div key={`default-${type}`} className="mb-3">
                                  <Form.Check 
                                    type={type}
                                    id={`default-${type}-1`}
                                    label={`Science`}
                                  />
                                </div>
                              ))}
                            </Form>
                          </div>
                      </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>Program Type</Accordion.Header>
                      <Accordion.Body>
                          <div className="check_type">
                            <Form>
                              {['checkbox'].map((type) => (
                                <div key={`default-${type}`} className="mb-3">
                                  <Form.Check 
                                    type={type}
                                    id={`default-${type}-1`}
                                    label={`Science`}
                                  />
                                </div>
                              ))}
                            </Form>
                          </div>
                      </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>College Type</Accordion.Header>
                      <Accordion.Body>
                          <div className="check_type">
                            <Form>
                              {['checkbox'].map((type) => (
                                <div key={`default-${type}`} className="mb-3">
                                  <Form.Check 
                                    type={type}
                                    id={`default-${type}-1`}
                                    label={`Science`}
                                  />
                                </div>
                              ))}
                            </Form>
                          </div>
                      </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="6">
                    <Accordion.Header>Exam Acceptance</Accordion.Header>
                      <Accordion.Body>
                          <div className="check_type">
                            <Form>
                              {['checkbox'].map((type) => (
                                <div key={`default-${type}`} className="mb-3">
                                  <Form.Check 
                                    type={type}
                                    id={`default-${type}-1`}
                                    label={`Science`}
                                  />
                                </div>
                              ))}
                            </Form>
                          </div>
                      </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
            </div>
            <div className="fees">
                 <div className="head">
                      <h5>Fees</h5>
                 </div>
                <div className="fees_manage_range">
                    <MultiRangeSlider
                      min={0}
                      max={100}
                      step={5}
                      ruler={false}
                      label={false}
                      preventWheel={false}
                      minValue={value.min}
                      maxValue={value.max}
                      onInput={(e) => {
                        handleInput(e);
                      }}
                    />
                </div>
                <div className="min_max">
                     <div className="min">
                          <p>Min</p>
                          <Form>
                            <Form.Control type="text" placeholder="" value="$20" />
                          </Form>
                     </div>
                     <div className="max">
                          <p>Max</p>
                          <Form>
                            <Form.Control type="text" placeholder="" value="$80" />
                          </Form>
                     </div>
                </div>
            </div>
            <div className="fees">
                 <div className="head">
                      <h5>Duration</h5>
                 </div>
                <div className="fees_manage_range">
                    <MultiRangeSlider
                      min={5}
                      max={100}
                      step={5}
                      ruler={false}
                      label={false}
                      preventWheel={false}
                      minValue={duration.min}
                      maxValue={duration.max}
                      onInput={(e) => {
                        setDuration({...duration, min: e.minValue, max: e.maxValue})
                      }}
                    />
              </div>
              <div className="min_max">
                     <div className="min">
                          <p>Min</p>
                          <Form>
                            <Form.Control type="text" placeholder="" value="2 Year" />
                          </Form>
                     </div>
                     <div className="max">
                          <p>Max</p>
                          <Form>
                            <Form.Control type="text" placeholder="" value="5 Year" />
                          </Form>
                     </div>
                </div>
            </div>
            <div className="fees">
                 <div className="head">
                      <h5>Ratings & Review</h5>
                 </div>
                <div className="rating_accdn">
                <Rating
                      onClick={handleRating}
                      ratingValue={rating}
                      showTooltip={false}
                      tooltipDefaultText="ABCD"
                      tooltipArray={["0.1", "0.3", "5.7", "7.8", "EXC"]}
                  />
              </div>
            </div>
      </div>
    );
}

export default Sidebar;
